import React from 'react'
import { Link } from 'react-router-dom'

import { H2, Button } from '../Common'

import style from './ForgotPasswordFinished.scss'

import sendEmail from '../../images/emojis/sendEmail.svg'

export default function() {
  return (
    <div className={style.wrapper}>
      <img src={sendEmail} alt="e-mail" />
      <H2>verifique seu e-mail!</H2>
      <p>foi enviado um e-mail com o link para redefinir a senha da sua conta na plataforma.</p>
      <Link to="/login">
        <Button xl>voltar</Button>
      </Link>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Pages/ForgotPasswordFinished.js